export interface Adjusted {
  impressions: number;
  netSpend: number;
  spend: number;
}

export interface Booked {
  simple: Adjusted;
  adjusted: Adjusted;
}

export type Ideal = Adjusted;

export interface AdjustedWithIdeal extends Adjusted {
  ideal: Ideal;
}

export interface Day {
  adjusted: AdjustedWithIdeal;
  date: string;
  simple: AdjustedWithIdeal;
}

export interface Alert {
  simple: { impressions: true; spend: true };
  adjusted: { impressions: true; spend: true };
}

export interface SummaryData {
  booked: Booked;
  cleared: Booked;
  end: string;
  projection: Booked;
  start: string;
}

export interface PacingSubData {
  company?: string;
  alert: Alert;
  booked: Booked;
  cleared: Booked;
  days?: Record<string, Day>;
  derived_network: string;
  description: string;
  key: string;
  network: string;
  platform: string;
  projection: Booked;
}

export interface PacingData {
  audio_buy_type?: string;
  description?: string;
  network?: string;
  booked: Booked;
  cleared: Booked;
  company: string;
  key: string;
  platform: string;
  projection: Booked;
  subData?: PacingSubData[];
}

export type PacingItem = PacingData | PacingSubData;

export interface PacingFetchParams {
  audio_buy_type?: string;
  company?: string;
  description?: string;
  end: string;
  globalPlatform?: string;
  groupByNetwork?: number;
  network?: string;
  platform?: string;
  start: string;
  useNetworkGroup?: number;
}

export type SimplicityKey = 'simple' | 'adjusted';
export type DimensionKey = 'impressions' | 'spend';

export const DATE_FORMAT = 'yyyy-MM-dd';

export const IMPRESSIONS_LABEL = 'Imps';
export const SPEND_LABEL = 'Spend';

export const SIMPLE_LABEL = 'Simple';
export const ADJUSTED_LABEL = 'Adjusted';

export const BY_COMPANY_LABEL = 'Company';
export const USE_NETWORK_LABEL = 'Network';
export const USE_NETWORK_GROUP_LABEL = 'Network Group';

export const BY_COMPANY_KEY = 'companies';
export const BY_NETWORK_KEY = 'networks';
export const USE_NETWORK_KEY = 'network';
export const USE_NETWORK_GROUP_KEY = 'network group';

export const PLATFORM_DISPLAY = 'Display';
export const PLATFORM_STREAMING = 'Streaming';

// The values the backend accepts as `globalPlatform` for the Streaming page's media type dropdown.
export const MEDIA_TYPE_BOTH = 'Streaming_Audio';
export const MEDIA_TYPE_STREAMING = 'Streaming';
export const MEDIA_TYPE_AUDIO = 'Audio';
